<span *ngIf="(review | async) as r">
  <button *ngIf="r.status === 'needed' || r.status === 'rejected'" class="btn btn-primary" style="margin-right: 5px;"
          (click)="approve(r)">Approve</button>
  <button *ngIf="r.status === 'needed'" class="btn btn-warning" (click)="reject(r)">Reject</button>
</span>
